import React, { Component } from "react";
import EirFieldset from '../eirFieldset/EirFieldset'
import { Form, FormGroup, Input, Label, Row, Col } from "reactstrap";
import EirButton from '../eir-button/EirButton'
import { EIR_WEBMAIL_CONST } from './constants/EirWebmailConstants'
class EirWebmailLogin extends Component {
    // add a constructor to the class to initialize the states
    constructor(props) {
        super(props);
        this.userID = React.createRef();
        this.userPwd = React.createRef();
        this.subscriberType = React.createRef();
        this.isLoginAccount = React.createRef();
        this.loginWebmailBtn = React.createRef();
        this.state = {
            // environment:  this.props.environment,
            loginStatus: [],
            userDetails: [],
            loginError: false,
            loginPasswordError: false,
            showHide: "show",
            invalidUser: false,
            ceasedAccount: false,
            disabledAccount:false,
            lockedOutAccount: false,
            forgotPwdLink: EIR_WEBMAIL_CONST.url.FORGOT_PASSWORD_URL,
            supportLink : EIR_WEBMAIL_CONST.url.WEBMAIL_SUPPORT_URL
        };
    }
    componentDidMount = () => {
        $(".account-mgmt-btn").removeClass("btn-primary").addClass("btn-outline-primary eir-text-secondary");
        window.location.search.indexOf("error=22") > 0 ? (this.setState({invalidUser: true})) : (this.setState({invalidUser: false}));
        window.location.search.indexOf("error=24") > 0 ? (this.setState({lockedOutAccount: true})) : (this.setState({lockedOutAccount: false}));
        window.location.search.indexOf("error=25") > 0 ? (this.setState({disabledAccount: true})) : (this.setState({disabledAccount: false}));
        window.location.search.indexOf("error=23") > 0 ? (this.setState({ceasedAccount: true})) : (this.setState({ceasedAccount: false}))
    }
    handleLogin = (e) => {
        // if (this.userPwd.current.value.trim().length < 8 || this.userPwd.current.value.trim().length > 16) {
        //     this.setState({ loginPasswordError: true })
        //     this.setState({ loginError: false });
        // }else 
        if (this.userID.current.value.trim().length < 1 || this.userPwd.current.value.trim().length < 1) {
            this.setState({ loginError: true })
           // this.setState({ loginPasswordError: false }); 
        } else {
            this.setState({ loginError: false });
           // this.setState({ loginPasswordError: false });  
            this.userID.current.value = this.userID.current.value.toLowerCase();
            (e.target.classList.contains("account-mgmt-btn")) ? this.isLoginAccount.current.value = "yes" : this.isLoginAccount.current.value = "no"
            document.forms[0].action = "/Email/newLogin.htm";
            document.forms[0].submit();
        }
    }
    handlePassword = (event) => {        
        if (this.userPwd.current.value.trim().length < 8 || this.userPwd.current.value.trim().length > 16) {
            //this.setState({ loginPasswordError: true })
           // document.getElementById("password").focus();
            
        } else {
          //  this.setState({ loginPasswordError: false });            
        }
    }
    basicVersionLogin = (event) => {
        if (this.userID.current.value.trim().length < 1 || this.userPwd.current.value.trim().length < 1) {
            this.setState({ loginError: true });
            event.preventDefault();
        } else {
            this.setState({ loginError: false })
            $(".webmail-btn").click();
        }
    }

    renderContent = (content) => {
        return { __html: content };
    }
    showHide = () => {
        (this.state.showHide == "hide") ? this.setState({showHide : "show"}) : this.setState({showHide : "hide"})
    }
    render() {
        return (
            <div className=" mb-3 mb-md-5 mt-4 eir-theme-default container webmail-container">
                {/* Do not delete - below is to get the image from OpenCMS - may be used later */}
                {/* <img className="mt-4" src={this.props.image} /> */}
                {this.props.text.trim(). length > 0 &&
                <p className="mt-4 eir-text text-left" dangerouslySetInnerHTML={this.renderContent(this.props.text)}></p>
                }
                {this.state.invalidUser &&
                <div id="ErrorMessage" className="row content-block">
                    <div class="large-12 columns">
                        <h3>Login error</h3>
                        <p className='forgotten-password-text'>Please enter a valid email/password. <a aria-label='Forgotten your password' href={this.state.forgotPwdLink}>Forgotten your password?</a></p>
                    </div>
                </div>
                }
                {this.state.ceasedAccount &&
                <div id="ErrorMessage" className="row content-block">
                    <div class="large-12 columns">
                        <h3>Login error</h3>
                        <p>This account has been closed at the request of the account holder.</p>
                    </div>
                </div>
                }
                 {this.state.lockedOutAccount &&
                <div id="ErrorMessage" className="row content-block">
                    <div class="large-12 columns">
                        <h3>Login error</h3>
                        <p>Payment is required to unlock your eir webmail account, to unlock please log into your webmail account management page and make a payment.</p>
                    </div>
                </div>
                }
                {this.state.disabledAccount &&
                <div id="ErrorMessage" className="row content-block">
                    <div class="large-12 columns">
                        <h3>Login error</h3>
                        <p>Please note this account has been disabled. Please call our customer support team on 1800 201 042 for more details.</p>
                    </div>
                </div>
                }
                <EirFieldset legend={this.props.title} border='solid'>
                    <Form id="login-form-email" method="post">
                        <Row className="col-lg-12 p-4 ml-1 login-form-body">
                            <Col className="login-form col-lg-8 login-input">
                                <FormGroup className="col-lg-6">
                                    <Label htmlFor="emailAddress" className="white">Email</Label>
                                    <Input type="text" name="username" id="username" innerRef={this.userID} placeholder="Email address" className={(this.state.loginError) ? 'border-danger' : ''} />
                                </FormGroup>
                                <FormGroup className="col-lg-6">
                                    <Label htmlFor="password" className="white ">Password</Label>
                                    <Input type={(this.state.showHide == 'hide') ? "text" : "password"} id="password" name="password" onBlur={this.handlePassword} innerRef={this.userPwd} placeholder="Password" className={(this.state.loginError) ? 'border-danger' : ''} />
                                    <span className="show-hide-pwd" onClick={this.showHide}>{this.state.showHide}</span>
                                </FormGroup>
                                <div className="col-lg-12 pb-4 login-form-links">
                                    <span className="float-left basic-version-check" onClick={this.basicVersionLogin}>
                                        <Label htmlFor="basic-version" className="basicVersionLabel">
                                            <input id="basic-version" className="basic-version-checkbox" name="htmlClient" type="checkbox" value="true" />Login using&nbsp;
                                            <span>basic version</span>
                                        </Label>
                                    </span>
                                        {/* <input id="basic-version" className="basic-version-checkbox" name="htmlClient" type="checkbox" value="true"></input>
                                         Login using&nbsp;</span>
                                    <a className="float-left col-lg-4 pl-0 pr-0" target="_blank" rel="noopener noreferrer" onClick={this.basicVersionLogin}  title="Login using basic version">basic version</a> */}
                                    <a aria-label='Trouble logging in' className="float-left col-lg-5 pl-2 pr-0" target="_blank" rel="noopener noreferrer" href={this.state.forgotPwdLink} title="Trouble logging in">Trouble logging in?</a>
                                </div>
                                <div className="col-lg-12 pb-2 pt-2 mb-4 text-danger">
                                    {this.state.loginError &&
                                        <span>Please enter a valid email/password</span>
                                    }
                                    {this.state.loginPasswordError &&
                                        <span>Please enter a valid password. it should be between 8 and 16 chars long</span>
                                    }
                                </div>
                                <div className="col-lg-12 text-center mt-3">
                                    <EirButton
                                        type="button"
                                        text="Login to webmail"
                                        onClick={this.handleLogin}
                                        className="btn btn-primary mr-2 ml-2 webmail-btn"
                                        id={"emailCTA"}
                                        ref="loginWebmailBtn"
                                    />
                                    <EirButton
                                        type="button"
                                        text="Manage my account"
                                        onClick={this.handleLogin}
                                        className="account-mgmt-btn"
                                        id={"accountCTA"}
                                    />
                                </div>
                            </Col>

                            <Col className="login-form col-lg-4" >
                                <FormGroup className="col-lg-12 text-center">
                                    <Label htmlFor="support" className="white">Support</Label>
                                </FormGroup>
                                <div className="support-image-ctr">
                                    <a href={this.state.supportLink} target="_blank" title="Webmail support"><img src={this.props.supportimage} border="0" alt="Webmail support" /></a>
                                </div>
                            </Col>
                        </Row>
                        {/* Below hidden is to navigate the user to account management page */}
                        <Input type="hidden" name="isLoginAccount" id="isLoginAccount" innerRef={this.isLoginAccount} />
                    </Form>
                </EirFieldset>
            </div>
        )
    }
}
export default EirWebmailLogin;